import React, { useMemo } from 'react';
import { TournamentContext, TournamentContextValue } from '@riptik/tournament-backoffice-module';
import { useTenant } from '../contexts/TenantContext';
import { useTranslation } from '../hooks/useTranslation';
import { useEventContext } from '../contexts/EventContext';
import { tournamentDownload, tournamentRequest } from '../api/client-tournament';

/** Host provider của module giải đấu (ticket 107): organizer = organization_slug của tenant; trang công khai nằm ở webshop `/giai-dau/:slug`. */
export const TournamentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const tenant = useTenant();
  const { t } = useTranslation();
  const { getOrgUrl } = useEventContext();
  const organizationSlug = tenant?.organization_slug;

  const value = useMemo<TournamentContextValue | null>(() => {
    if (!organizationSlug) return null;
    const webshop = (import.meta.env.VITE_WEBSHOP_URL as string | undefined) || '';
    return {
      organizationSlug,
      t,
      request: (path, body, method) => tournamentRequest(organizationSlug, path, body, method),
      download: (path, filename) => tournamentDownload(organizationSlug, path, filename),
      publicUrl: (slug) => `${webshop}/o/${encodeURIComponent(organizationSlug)}/giai-dau/${encodeURIComponent(slug)}`,
      getOrgUrl,
    };
  }, [organizationSlug, t, getOrgUrl]);

  if (!value) return null;
  return <TournamentContext.Provider value={value}>{children}</TournamentContext.Provider>;
};
